<div class="container">
    <div class="header-container">
        <span class="h3-regular header-title">{{ currPage.id }}</span>
    </div>
    <div class="body-container" *ngIf="autoTagging && allNoteTypes">
        <div>
            <span class="span-autotag body-3">Enable Auto Tagging for Notes</span>
        </div>
        <div class="switch-autotag inner-block-top">
            <kendo-switch [checked]="autoTagging.enable" onLabel="Yes" offLabel="No"
                (valueChange)="changeAutoTaggingStatus($event)"></kendo-switch>
        </div>
        <div class="items-autotag block-top">
            <div class="model">
                <div>
                    <span class="span-autotag body-3">Auto Tagging Model</span><span
                        class="required-field span-star">*</span>
                </div>
                <div class="inner-block-top">
                    <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" class="kendo-dropdownlist"
                        [(ngModel)]='selectedModel' [disabled]="modelDisabled" [data]="modelData"
                        (selectionChange)="changeTaggingModel($event)" [filterable]="false" [textField]="'text'"
                        [valueField]="'value'">
                    </kendo-dropdownlist>
                </div>
            </div>
            <div class="note-types">
                <div>
                    <span class="span-autotag body-3">Entry Types</span><span class="required-field span-star">*</span>
                </div>
                <div class="inner-block-top">
                    <multi-sel-dropdown-filter #multiSelDropdownFilter [dropdownConfig]="dropdownConfig">
                    </multi-sel-dropdown-filter>
                </div>
            </div>
            <div class="Probability-Threshold">
                <div>
                    <span class="span-autotag body-3">Confidence Threshold</span><span
                        class="required-field span-star">*</span>
                </div>
                <div class="numerictextbox inner-block-top">
                    <kendo-numerictextbox [format]="'n2'" [step]="0.05" [min]="0.2" [max]="1.0"
                        (valueChange)="changeConfidence()" [(ngModel)]="autoTagging.confidence">
                    </kendo-numerictextbox>
                </div>
            </div>
            <div class="btn-cancelsave">
                <button tam-button tamType="tertiary" tamSize="normal" [disabled]="btnCancelDisabled"
                    (click)="onCancel()" class="dialog-button dialog-cancel btn-cancel">Cancel</button>
                <button tam-button tamType="primary" tamSize="normal" (click)="onSave()" [tamLoading]="isProgressing"
                    [disabled]="isProgressing||btnSaveDisabled"
                    class="dialog-button dialog-publish btn-save">Save</button>
            </div>
        </div>
        <div class="block-top">
            <span class="span-autotag body-3">Enable Auto Tagging For Livewire</span>
        </div>
        <div class="switch-autotag inner-block-top">
            <kendo-switch [checked]="autoTagging.enableForLiveWire" onLabel="Yes" offLabel="No"
                (valueChange)="changeAutoTaggingStatusForLivewire($event)"></kendo-switch>
        </div>
        <div class="block-top">
            <button tam-button tamType="primary" tamSize="normal" (click)="onCreateNewModel()"
                class="dialog-button dialog-publish btn-save">Create New Model</button>
        </div>
    </div>
</div>